// extracted by mini-css-extract-plugin
export default {"navigation":"frame__navigation__AYxxUb","slideOverNav":"frame__slideOverNav__uAb4RJ","open":"frame__open__tqeV1p"};